import { loadStripe } from "@stripe/stripe-js";
import { createSubscriptionCheckoutSessionWithTrial } from "./audiblogsApi";
const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
const stripePromise = loadStripe(STRIPE_API_KEY);

export const createStripeSessionAndRedirectToCheckout = async (
  idToken,
  options = {}
) => {
  try {
    const stripe = await stripePromise;
    
    // If options.mode is payment, create a one-time payment session
    if (options.mode === 'payment') {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/payments/create_checkout_session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Audiblogs-Id-Token': idToken
        },
        body: JSON.stringify({
          mode: 'payment',
          amount: options.amount,
          currency: options.currency || 'usd',
          metadata: options.metadata || {}
        })
      });
      
      const data = await response.json();
      if (data.sessionId) {
        return stripe.redirectToCheckout({
          sessionId: data.sessionId,
        });
      }
      throw new Error('Failed to create checkout session');
    }
    
    // Otherwise create a subscription session
    const data = await createSubscriptionCheckoutSessionWithTrial(true, idToken);
    if (data.data.sessionId) {
      return stripe.redirectToCheckout({
        sessionId: data.data.sessionId,
      });
    }
    throw new Error('Failed to create subscription session');
  } catch (e) {
    console.error('Error in createStripeSessionAndRedirectToCheckout:', e);
    throw e;
  }
};
